<div class="dashboard-container">
	<mat-toolbar class="toolbar">
		<div class="container flex flex-row items-center justify-between top-bar">
			<div class="logo-container flex flex-row items-center">
				<img src="../../../assets/obd-logo.svg" alt="OBD LOGO" />
				<h2>Onboarding Digital</h2>
			</div>
			<div class="url-info-container">
				<h2 class="text-3xl">{{ currentRouteName }}</h2>
			</div>
		</div>
	</mat-toolbar>
	<div class="background flex flex-row h-full pt-5 w-full">
		<app-sidebar class="px-5"></app-sidebar>
		<div class="wrapper component-background w-full">
			<app-edit-avatar class="ml-5"></app-edit-avatar>
            <app-filters-edit class="ml-5"></app-filters-edit>
			<app-dashboard-footer></app-dashboard-footer>
		</div>
	</div>
</div>